








import { defineComponent } from '@nuxtjs/composition-api';
import BaseNotifications from '@/components/BaseNotifications/BaseNotifications.vue';

export default defineComponent({
  name: 'Blank',
  components: {
    BaseNotifications,
  },
});
